var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "8772E52B-C295-4E75-A1D1-1BA4DA8D2BEE")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AssetSheet",
    transform: "translate(-584.000000, -511.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Linkedin",
    transform: "translate(584.000000, 511.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.43,0 L1.58,0 C0.7,0 0,0.7 0,1.4875 L0,19.425 C0,20.2125 0.7,20.9125 1.58,20.9125 L19.43,20.9125 C20.3,20.9125 21,20.2125 21,19.425 L21,1.4875 C21,0.7 20.3,0 19.43,0 Z M6.21,17.85 L3.15,17.85 L3.15,7.875 L6.21,7.875 L6.21,17.85 Z M4.72,6.475 C3.76,6.475 2.89,5.6875 2.89,4.6375 C2.89,3.5875 3.67,2.8 4.72,2.8 C5.69,2.8 6.56,3.5875 6.56,4.6375 C6.56,5.6875 5.69,6.475 4.72,6.475 Z M17.94,17.7625 L14.88,17.7625 L14.88,12.8625 C14.88,11.725 14.88,10.15 13.21,10.15 C11.55,10.15 11.38,11.4625 11.38,12.6875 L11.38,17.675 L8.31,17.675 L8.31,7.875 L11.2,7.875 L11.2,9.1875 L11.29,9.1875 C11.72,8.4 12.77,7.525 14.26,7.525 C17.41,7.525 18.02,9.625 18.02,12.3375 L18.02,17.7625 L17.94,17.7625 Z",
    id: "Shape"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.1c2b95e5.svg";
export { ForwardRef as ReactComponent };